import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
export default function CircularProgress ({ className, start, duration = 10, onComplete, ...props }) {
  const pathRef = useRef()
  useEffect(() => {
    if (!pathRef.current || !start) return
    const tl = gsap.timeline()
    tl.fromTo(pathRef.current, { strokeDashoffset: 300 }, { strokeDashoffset: 0, duration, ease: 'none', onComplete })
    return () => {
      tl.kill()
    }
  }, [start, duration, onComplete])

  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 100 100'
      {...props}
    >
      <path
        d='
          M 50,50
          m 0,-46
          a 46,46 0 1 1 0,92
          a 46,46 0 1 1 0,-92
        '
        strokeWidth='8'
        stroke='currentColor'
        fillOpacity='0'
        style={{ opacity: 0.5, strokeDasharray: '300px, 300px', strokeDashoffset: '0px' }}
      />
      <path
        ref={pathRef}
        d='
          M 50,50
          m 0,-46
          a 46,46 0 1 1 0,92
          a 46,46 0 1 1 0,-92
        ' strokeWidth='8' stroke='currentColor' fillOpacity='0' style={{ strokeDasharray: '300px, 300px', strokeDashoffset: '300px' }}
      />
    </svg>
  )
}
